export function coerceToNullableNumber(input: unknown): number | null {
   if (typeof input === 'string') {
      return input.trim() === '' ? null : Number(input);
   }
   return input as number | null;
}
